import { ApiException, DocumentsApi, DocumentViewModel, FileResponse } from '@ail/documents-api'
import { createApi } from '@reduxjs/toolkit/query/react'
import { USER_MANAGER } from '../../auth/userManager'
import { Constants } from '../../helpers/Constants'
import { getBaseQuery } from './apiQuery'

const client = new DocumentsApi({
  baseUrl: Constants.documentEndpoint,
  getToken: async () => {
    const user = await USER_MANAGER.getUser()
    return user?.access_token ?? ''
  },
})

// prettier-ignore
export const documentsApi = createApi({
  reducerPath: 'documentsApi',
  baseQuery: getBaseQuery<ApiException>(),
  endpoints: (builder) => ({
    downloadDocument: builder.query<FileResponse, { documentId: string }>({
      query: (model) => client.downloadDocument(model.documentId),
    }),
    getContractDocument: builder.query<FileResponse, { contractId: string; fileName: string }>({
      query: (model) => client.getContractDocument(model.contractId, model.fileName),
    }),
    getContractDocuments: builder.query<DocumentViewModel[], { contractId: string; excludeRestricted?: boolean }>({
      query: (model) => client.getContractDocuments(model.contractId, model.excludeRestricted),
    }),
    getDocumentsApiHealth: builder.query<{ status: 'Healthy' | 'Degraded' | 'Unhealthy' }, void>({
      query: () => fetch(`${Constants.documentEndpoint}/health`).then((r) => r.ok ? r.json() : { status: 'Unhealthy' }).then((r) => ({ data: r })),
    }),
  }),
})

export const { useGetContractDocumentsQuery, useLazyDownloadDocumentQuery, useGetDocumentsApiHealthQuery } =
  documentsApi
